import React, { useRef, useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lottie from "lottie-react";
import playAnim from "../animation/Cursorpulsing.json";
import scrollAnim from "../animation/ScrollDown.json";
import arrowAnim from "../animation/ArrowDownBounce.json";
import "../styles/HomePage.css";
import Footer from '../component/footer';

const apiUrl = process.env.REACT_APP_API_URL;
const mobileWifiUrl = process.env.REACT_APP_MOBILE_WIFI_URL;
const cdnURL = process.env.REACT_APP_CDN_URL;

const media = [
  // { type: "video", src: `${cdnURL}/video/homepage_animation_new.mp4` },
  { type: "image", src: `${cdnURL}/images/ets38bannerupgrade.png`, link: `${mobileWifiUrl}/postpaid/ets38` },
  // { type: "image", src: `${cdnURL}/images/race-return-to-malaysia-1920x1168.png`, link: `/race` },
];


const lines = [
  "Malaysia’s first public listed MVNO,",
  <>trusted<span className="highlight"> by millions</span> of subscribers. </>,
  "Rooted in Malaysia and expanding beyond, we are leading the evolution",
  "towards an artificial intelligence powered digital economy that redefines how",
  "people connect, create and thrive in a smarter, more connected world."
]

const brands = [
  { id: 1, name: "ONEXOX 5G", logo: `${cdnURL}/logo/logo_onexox5Gesim_selected.svg`, description: "Built to give more speed, freedom & value to power your everyday life. ONEXOX 5G’s affordable & flexible plans make seamless connectivity a constant you can always count on.", link: `${mobileWifiUrl}/prepaid/onex5g`},
  { id: 2, name: "XOX 5G", logo: `${cdnURL}/logo/logo_XOX5Gesim_selected.svg`, description: "The premium experience that delivers on every front. From lightning-fast connectivity and exclusive perks, to global access at your fingertips, XOX 5G keeps you fully in control.", link: `${mobileWifiUrl}/postpaid/postpaid5g`},
  { id: 3, name: "spaceX", logo: `${cdnURL}/logo/logo_spaceX_selected.svg`, description: "Revolutionising retail convenience, Malaysia’s first AI-powered vending ecosystem brings smart automation to life, where meaningful engagements are easier than ever to create.", link: "/spacedx"}
];

const HomePage = () => {

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const displayPosts = [...posts, ...posts];
  const limitedPosts = displayPosts.slice(0, 5);
  const trackPosts = [...limitedPosts, ...limitedPosts, ...limitedPosts];

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const sliderSettings = useMemo(() => ({
      infinite: true,
      slidesToShow: 3,
      centerMode: false,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 10,    
      speed: 12000,         
      cssEase: "linear",   
      pauseOnHover: false,
      pauseOnFocus: false,
      swipe: false,
      rtl: false,

  }), []);

  let globalIndex = 0;
  let globalIndex2 = 0;

  const renderCharacters = (text, extraClass = "") =>
    text.split("").map((char) => {
      const index = globalIndex++;
      return (
        <span
          key={index}
          className={`${extraClass} ${isVisible ? "animate" : ""}`}
          style={{ animationDelay: `${index * 0.02}s` }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      );
    });

    const renderCharacters2 = (text, extraClass = "") =>
    text.split("").map((char) => {
      const index = globalIndex2++;
      return (
        <span
          key={index}
          className={`${extraClass} ${isVisible ? "animate" : ""}`}
          style={{ animationDelay: `${index * 0.02}s`, fontWeight: 700 }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      );
    });

  const renderLine = (line) => {
    if (typeof line === "string") {
      return renderCharacters(line);
    }
    if (React.isValidElement(line)) {
      return React.Children.map(line.props.children, (child) => {
        if (typeof child === "string") {
          return renderCharacters(child);
        }
        if (React.isValidElement(child)) {
          return renderCharacters(child.props.children, child.props.className);
        }
      });
    }
  };

  const renderImage = (src, alt = "", className = "") => {
    const index = globalIndex2++;

    return (
      <span
        key={`img-${index}`}
        className={`${className} ${isVisible ? "animate" : ""}`}
        style={{ animationDelay: `${index * 0.02}s`, display: "inline-block" }}
      >
        <img src={src} alt={alt} />
      </span>
    );
  };

  const renderPartnershipLine = () => (
    <>
      {renderCharacters2("In partnership with ")}
      {renderImage(`${cdnURL}/logo/celcomdigi_logo.svg`, "Partner Logo", "partner-logo")}
    </>
  );



  const handlePlayPause = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % brands.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev - 1 + brands.length) % brands.length);
  };

  const goToSlide = (index) => {
    if (index === activeIndex) return; 
    setActiveIndex(index);
  }

  const getClass = (index) => {
    if (index === activeIndex) return "brand center";
    if (index === (activeIndex - 1 + brands.length) % brands.length)
      return "brand left";
    if (index === (activeIndex + 1) % brands.length) return "brand right";
    return "brand hidden"; 
  };
  
  const handleResize = () => {
      setScreenWidth(window.innerWidth);
  };

  const handleScroll = () => {
    const section = document.querySelector(".section-two");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const marqueeRef = useRef(null);

  useEffect(() => {
    if (!posts.length || !marqueeRef.current) return;

    const el = marqueeRef.current;

    const images = el.querySelectorAll("img");

    Promise.all(
      [...images].map((img) => {
        if (img.complete) return Promise.resolve();

        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      })
    ).then(() => {
      // restart animation after images loaded
      el.style.animation = "none";

      void el.offsetHeight;

      el.style.animation = "marquee 35s linear infinite";
    });
  }, [posts]);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            
          }
        });
      },
      { root: null, 
        rootMargin: "30% 0px 0px 0px",
        threshold: 0.3 } 
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);

    video.addEventListener("play", onPlay);
    video.addEventListener("pause", onPause);

    return () => {
      video.removeEventListener("play", onPlay);
      video.removeEventListener("pause", onPause);
    };
  }, []);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/instagram/posts`);
        if (res.data?.data) {
          const imagePosts = res.data.data.filter((post) => post.media_type === "IMAGE");

          setPosts((prev) => {
            const prevUrls = prev.map((p) => p.media_url).join(",");
            const newUrls = imagePosts.map((p) => p.media_url).join(",");
            return prevUrls !== newUrls ? imagePosts : prev;
          });
        }
        setTimeout(() => setLoading(false), 200);
      } catch (err) {
        console.error("Error fetching posts:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  useEffect(() => {
    if (posts.length > 0) {
      posts.forEach(p => {
        const img = new Image();
        img.src = p.media_url;
      });
    }
  }, [posts]);


  useEffect(() => {
      window.removeEventListener('resize', handleResize);
      return () => {
          window.removeEventListener('resize', handleResize);
      }
  });

  return (
    <div>
      
      <div className="section top-banner">

        {/* <div className={`banner-text ${isLoaded ? "visible" : "hidden"}`}>
          <h2>Where Imagination</h2>
          <h2 style={screenWidth > 600 ? {paddingLeft:"100px"} : {paddingLeft:"30px"}}>Meets Innovation</h2>

          <div className="banner-btn">
            <a className="btn btn-discover" href="/aboutus" style={{ "--arrow-icon": `url(${cdnURL}/icon/icon_red_arrow.svg)` }}> <span>Discover XOX</span></a>
          </div>
        </div> */}

        {/* <img src={`${cdnURL}/images/wave.png`} className="wave-overlay"></img> */}
        {screenWidth > 600 ?
        <div className="scroll-lottie" onClick={() => handleScroll()} >
            <img src={`${cdnURL}/images/blue_shadow_bg.png`} alt="" className="scroll-bg" />
            <Lottie animationData={scrollAnim} loop={true} />
            <Lottie animationData={arrowAnim} loop={true} className="arrow-lottie"/>
            <a>Scroll Down</a>
        </div> : null}
        
        <Swiper
          direction="vertical"
          slidesPerView={1}
          loop={true}
          modules={[Pagination, Autoplay]}
          pagination={media.length > 1 ? { clickable: true } : false}
          autoplay={{
            delay: 4000,   
            disableOnInteraction: false,
          }}
          //  autoHeight={true}
          className="swiper-container"
        >
          {media.map((item, index) => (
            <SwiperSlide key={index}>
                {item.type === "video" ? (
                <video
                  src={item.src}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="slider-video"
                  onLoadedData={() => setIsLoaded(true)}
                />
              ) : (
                <a href={item.link} rel="noopener noreferrer">
                  <img
                    src={item.src}
                    alt={`Slide ${index + 1}`}
                    className="w-100 h-auto d-block"
                    onLoad={() => setIsLoaded(true)}
                  />
                </a>
              )}
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
      

      {/* 2nd Section */}
      <div className="section-two">
        
        <video className="bg-image" autoPlay loop muted playsInline>
          <source src={`${cdnURL}/video/homepage_whoweare.mp4`} type="video/mp4" onLoadedData={() => setIsLoaded(true)}/>
        </video>

        <img src={`${cdnURL}/images/wave 1.png`} className="wave-overlay" alt="wave" />

        <div ref={sectionRef} className={`content-two ${isLoaded ? "visible" : "hidden"}`}>
            {lines.map((line, i) => (
              <React.Fragment key={i}>
               <p key={i}
                  className={`animated-text ${i < 2 ? "first-line": ""}`}>
                  {renderLine(line)}
               </p>
               {i === 1 && <div className="line-break-space"><br/><br/></div>}
              </React.Fragment>
            ))}
            <p className="animated-text partnership-line">
              {/* {renderPartnershipLine()} */}
            </p>
        </div>

        <div className={`section-three ${isLoaded ? "visible" : "hidden"}`}>
            <div className="sec-brand">
              <p> OUR BRANDS </p>
              <span> OUR BRANDS</span>
            </div>

            <div className="brand-slider-wrapper">
              <div className="brand-slider">
                  <button onClick={prevSlide} className="nav-btnHP">
                      <Lottie animationData={arrowAnim} loop={true} style={{transform: "rotate(90deg)" }} className="arrow-brand"/>
                  </button>

                    <div className="brands">
                      {brands.map((b, i) => (
                        <div key={b.id} className={getClass(i)} onClick={() => goToSlide(i)}>
                          <div className="brand-core">
                            <img src={b.logo} alt={b.name} />
                            <p>{b.name}</p>
                          </div>

                        </div>
                      ))}
                    </div>

                  <button onClick={nextSlide} className="nav-btnHP">
                      <Lottie animationData={arrowAnim} loop={true} style={{transform: "rotate(-90deg)" }} className="arrow-brand"/>
                  </button>

              </div>
            </div>
              {brands[activeIndex] && (
                <div className="brand-details">
                  <p>{brands[activeIndex].description}</p>
                  <a href={brands[activeIndex].link} target="_blank" rel="noopener noreferrer" className="learn-more btn btn-discover" style={{ "--arrow-icon": `url(${cdnURL}/icon/icon_red_arrow.svg)` }}>
                    <span>Learn More</span>
                  </a>
                </div>
              )}
        </div>

      </div>


      {/* Video Section */}
      <div className="video-container" onClick={handlePlayPause}>
        <video ref={videoRef} width="100%" height="100%" controls={false}>
          <source src={`${cdnURL}/video/XOXAGM2026.mp4`} type="video/mp4" />
        </video>

        {!isPlaying && (
          <>
          <img className="video-thumbnail" src={`${cdnURL}/images/Video_Cover_R1_esim.jpg`} alt="Video thumbnail" />
          <div className="play-button">
            <div className="circle-container">
              <div className="pulse-circle"></div>
              <div className="main-circle">
                <div className="triangle"></div>
              </div>
              {/* <Lottie animationData={playAnim} loop={true} play={true} style={{zIndex:"10"}} /> */}
            </div>
            <span className="text">WATCH VIDEO</span>
          </div>
          </>
        )}
      </div>

      <div className="footer-gradient">
        {/* Instagram-style Slider Section */}
        <div className="section container-fluid  my-5 ">
          <div className="container" style={{padding:"2.604vw 0px"}}>
              <h3 className="sec4 mb-4 text-center">LATEST UPDATES</h3>
          </div>
          {/* <Slider key={posts.length} {...sliderSettings}>
            {limitedPosts.map((post) => (
              <div key={post.id}  className="px-2">
                <div className="card shadow-sm insta-card">
                    <img
                      src={post.media_url}
                      alt={post.caption}
                      className="card-img-top insta-img"
                    />          
                </div>
              </div>
            ))}
          </Slider> */}
          <div className="marquee-container">
            <div className="marquee-track" ref={marqueeRef}>
              {/* {trackPosts.map((post, index) => (
                <div className="card shadow-sm insta-card" key={index}>
                  <img src={post.media_url} alt={post.caption || ""} className="card-img-top insta-img"/>
                </div>
              ))} */}
              {[...trackPosts, ...trackPosts].map((post, index) => (
                <div className="card shadow-sm insta-card" key={index}>
                  <img
                    src={post.media_url}
                    alt={post.caption || ""}
                    className="card-img-top insta-img"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{padding:"0px 5.208vw"}}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
